import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { BUILDBROZ_LOGO_URL } from '../branding';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/*
 * TEMPORARY BOOTSTRAP ACCESS GATE
 * -------------------------------
 * For this first Ops foundation step, all /ops routes are protected using the
 * EXISTING website admin authentication (admin_token in localStorage, verified
 * via GET /api/admin/verify). No new auth system, JWT behavior, token
 * expiration, or backend dependency is changed here.
 *
 * This is intentionally a placeholder gate and MUST be replaced/expanded when
 * multi-user BuildBroz Ops roles (employees, subcontractors, managers) are
 * introduced in a later development step.
 */
export const OpsAuthGuard = ({ children }) => {
  const [status, setStatus] = useState('checking'); // 'checking' | 'authed'
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const requested = `${location.pathname}${location.search}`;
    const loginUrl =
      requested === '/ops' ? '/ops/login' : `/ops/login?next=${encodeURIComponent(requested)}`;
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate(loginUrl, { replace: true });
      return;
    }
    axios
      .get(`${API}/admin/verify`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => setStatus('authed'))
      .catch(() => {
        localStorage.removeItem('admin_token');
        navigate(loginUrl, { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  if (status !== 'authed') {
    return (
      <div
        className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center gap-4"
        data-testid="ops-auth-loading"
      >
        <div className="flex flex-col items-center gap-2">
          <img
            src={BUILDBROZ_LOGO_URL}
            alt="BuildBroz Logo"
            className="h-24 w-auto mix-blend-screen"
          />
          <span className="text-xl font-bold text-white">
            BuildBroz <span className="text-[#D4AF37]">Ops</span>
          </span>
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#D4AF37]"></div>
        <p className="text-gray-500 text-sm">Verifying access…</p>
      </div>
    );
  }

  return children;
};
